import Vue from "vue";
import Vuex from "vuex";

import login from "./login/index";
import app from "./app/index";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    app,
    login,
  },
  plugins: [createPersistedState()],
});
